import MUIDataTable from "mui-datatables"

export default function TableColaborador({ data }) {
	const columns = [
		{
			name: "id",
			label: "ID",
			options: {
				filter: false,
				sort: false,
				display: false,
			},
		},
		{
			name: "status_name",
			label: "Estado",
			options: {
				filter: false,
				sort: true,
				display: true,
			},
		},
		{
			name: "deduccion",
			label: "Deducción",
			options: {
				customBodyRender: (value) => {
					return `$ ${value.toLocaleString()}`
				},
				filter: true,
				sort: true,
			},
		},
		{
			name: "fecha_solicitud",
			label: "Fecha de Solicitud",
			options: {
				filter: true,
				sort: true,
			},
		},
		{
			name: "fecha_ingreso",
			label: "Fecha de Ingreso",
			options: {
				filter: true,
				sort: true,
			},
		},
	]
	const options = {
		textLabels: {
			body: {
				noMatch: "No hay solicitudes",
			},
		},
		search: false,
		filter: false,
		download: false,
		print: false,
		viewColumns: false,
		selectableRows: "none",
	}

	return <MUIDataTable title={""} data={data} columns={columns} options={options} />
}
